import { useEffect, useRef } from "react";

const DynamicSVG = ({ url }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!url) return;

    fetch(url)
      .then(res => res.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "image/svg+xml");
        const svgEl = doc.querySelector("svg");
        if (svgEl && containerRef.current) {
          containerRef.current.innerHTML = "";
          containerRef.current.appendChild(svgEl);
        }
      });
  }, [url]);

  return <div className="svg-mobile-illustration" ref={containerRef} />;
};

export default DynamicSVG;
